import { Leaf, Heart, Scale } from 'lucide-react'

export const ESG_PILLARS = [
  {
    icon: Leaf,
    title: 'Environmental || Miljö',
    headline:
      'Clean production, minimal footprint || Ren produktion, minimalt fotavtryck',
    points: [
      'Inks free from PVC and harmful phthalates || Bläck fritt från PVC och skadliga ftalater',
      'Solar-powered facilities with LED lighting || Solcellsdrivna anläggningar med LED-belysning',
      'Zero-waste water recycling in production || Nollavfalls vattenåtervinning i produktion',
      'All packaging from FSC-certified sources || All förpackning från FSC-certifierade källor',
    ],
  },
  {
    icon: Heart,
    title: 'Social || Socialt',
    headline:
      'Made by people treated right || Tillverkad av människor som behandlas rätt',
    points: [
      'WRAP certified factory conditions || WRAP-certifierade fabriksförhållanden',
      'Oeko-Tex certified threads—safe for skin || Oeko-Tex-certifierade trådar—säkra för huden',
      "Recovered heat warms our team's workspace || Återvunnen värme värmer vårt teams arbetsplats",
      'Local jobs and community investment || Lokala jobb och samhällsinvesteringar',
    ],
  },
  {
    icon: Scale,
    title: 'Governance || Styrning',
    headline: 'Nothing to hide || Inget att dölja',
    points: [
      'Only vetted, responsible suppliers || Endast granskade, ansvarsfulla leverantörer',
      'Independently audited sustainability claims || Oberoende granskade hållbarhetspåståenden',
      'Ethical standards across every supplier || Etiska standarder hos varje leverantör',
      'Your data protected to GDPR standards || Din data skyddad enligt GDPR-standarder',
    ],
  },
] as const
